import { type GetHookResponse } from '../hooks'
import { userCheckKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type UserCheckInput, type UserCheckSuccess } from '@terros/common'

export function useUserCheck(): GetHookResponse<UserCheckSuccess> {
  return useTantalimQuery<UserCheckInput, UserCheckSuccess, UserCheckSuccess>({
    url: '/user/check',
    queryKey: userCheckKey(),
    input: {},
    convertResponse: (data) => data,
  })
}
